import Component from './component';

export interface Props {
    currentPage: number;
    lastPage: number;
    onPageChange?: (nextPage: number) => any;
    hrefBuilder?: (page: number) => string;
}

Component.defaultProps = {
    hrefBuilder: null,
    onPageChange: () => null,
};
export default Component;